import React from "react";

const Payment = () => {
  return (
    <div className="p-5">
      <h2>Payment system coming soon.</h2>
    </div>
  );
};

export default Payment;
